export default __webpack_public_path__ + "static/media/thunderstorm.8ef2ec78.mp4";